import React, { useMemo, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

import AddBookkeeperMaster from "./AddBookkeeperMaster"
import { deleteNow } from "helpers/delete_function"
import { axiosbaseurl } from "configure"
import moment from "moment"
import { setUpdatedData } from "helpers/data_setters"
import Loader from "components/Common/Loader"
import { usePermissionData } from "AppContext"
import PermittedComponent from "components/Common/PermittedComponent"
import CommonTable from "components/Common/CommonTable"

const AllBookkeepers = ({ module_id }) => {

    const [table_data, settable_data] = useState([])
    const [prefixOptions, setPrefixOptions] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const getBookkeepers = async () => {
            try {
                setLoading(true)
                const res = await axiosbaseurl.get(`/prefix-master/active`);
                setPrefixOptions(res.data.data)

                const response = await axiosbaseurl.get(`/bookkeeper`);
                if (response.data.success) {
                    settable_data(response.data.data.map(b => ({ ...b, prefix: b?.prefixNameById?.prefixName || '' })))
                }

            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)
            }
        }
        getBookkeepers()
    }, [])

    return (
        <>
            {loading && <Loader />}
            <TableComponent table_data={table_data} settable_data={settable_data}
                prefixOptions={prefixOptions} module_id={module_id} />
        </>
    )
}

const TableComponent = ({ table_data, settable_data, prefixOptions, module_id }) => {

    const [modalType, setModalType] = useState('');
    const [show, setShow] = useState(false);
    const [keeperId, setKeeperId] = useState("");

    const navigate = useNavigate()

    const { checkAccess, permissions } = usePermissionData()

    document.title = "Bookkeeper | Peacock Accountants Limited"

    const handleStatus = async (status, id) => {
        try {
            if (status) {
                const response = await axiosbaseurl.patch(`/bookkeeper/${id}/status`, { status });
                if (response.data.success) {
                    settable_data(prev => setUpdatedData(prev, response.data.data || response.data.status, "edit", "Status "))
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleDelete = async (id) => {
        try {
            const response = await axiosbaseurl.delete(`/bookkeeper/${id}`);
            if (response.data.success)
                settable_data(prev => setUpdatedData(prev, response.data.data, "delete"))

        } catch (error) {
            console.log(error)
            swal("", error.response.data.message || "Something went Wrong", "error")
        }
    }

    // columns
    const columns = useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
                filterable: true,
                disableFilters: true,
                className: "text-center",
                Cell: cellProps => (<span>{cellProps.row.index + 1}</span>),

            },
            {
                Header: "Prefix",
                accessor: "prefix",
                disableFilters: true,
                filterable: true
            },
            {
                Header: "Preferred Name",
                accessor: "preferredName",
                disableFilters: true,
                filterable: true
            },
            {
                Header: "Email Address",
                accessor: "email",
                disableFilters: true,
                filterable: true
            },
            {
                Header: "Created At",
                accessor: "createdAt",
                disableFilters: true,
                filterable: true,
                // className: " text-center",
                Cell: cellProps => {
                    return (
                        <span>{moment(cellProps.row.original.createdAt).format("DD MMM YYYY | hh:mm A")}</span>
                    )
                },
            },
            {
                Header: "Status",
        disableSort: true,
                accessor: "status",
                disableFilters: true,
                filterable: true,
                className: "text-center",
                Cell: cellProps => {
                    return (
                        <div className="text-center">
                            <select
                                onChange={(e) => handleStatus(e.target.value, cellProps.row.original.id)}
                                disabled={!checkAccess(module_id, "edit")}
                                className={`badge fs-6 border-0 status_select_dropdown 
                                    bg-${cellProps.row.original.status == "Active" ? "green" : "danger"}`}
                                value={cellProps.row.original.status}>
                                <option value="Active">Active</option>
                                <option value="InActive">InActive</option>
                            </select>
                        </div>
                    )
                },
            },
            {
                Header: "Action",
                disableFilters: true,
                disableSort: true,
                accessor: "view",
                className: "col-2 text-center",
                Cell: cellProps => {
                    return (
                        <div>

                            {
                                checkAccess(module_id, 'edit') &&
                                <button
                                    onClick={() => {
                                        setKeeperId(cellProps.row.original.id)
                                        setShow(true)
                                        setModalType('edit')
                                    }}
                                    className="btn btn-success bg-green  btn-sm me-2"
                                >
                                    <i className="fas fa-pen me-1"></i> Edit
                                </button>
                            }
                            {/* {
                                checkAccess(module_id, 'remove') &&
                                <button
                                    onClick={() => deleteNow(() => handleDelete(cellProps.row.original.id))}
                                    className="btn btn-danger btn-sm ml-10"
                                >
                                    <i className="fas fa-trash-alt"></i>
                                </button>
                            } */}
                        </div>
                    )
                },
            },
        ],
        [permissions]
    )

    // table data
    const data = useMemo(() => (table_data), [table_data])


    return (
        <>
            <PermittedComponent isAccess={checkAccess(module_id, "view")}>

                <CommonTable
                    columns={columns}
                    data={data}
                    heading={"Bookkeepers"}
                >
                    <div>
                        {
                            checkAccess(module_id, 'add') &&
                            <button onClick={() => {
                                setModalType('add')
                                setShow(true)
                            }} className="btn btn-primary bg-blue ms-3">
                                <i className="fas fa-plus me-2"></i>
                                Add Bookkeeper
                            </button>
                        }

                        <button onClick={() => navigate(-1)} className="btn btn-secondary bg-dark ms-3">
                            <i className="fas fa-arrow-left me-3"></i>
                            Back
                        </button>
                    </div>

                </CommonTable>

                <AddBookkeeperMaster
                    type={modalType}
                    show={show}
                    setShow={setShow}
                    keeperId={keeperId}
                    setKeeperId={setKeeperId}
                    settable_data={settable_data}
                    prefixOptions={prefixOptions}
                />

            </PermittedComponent>
        </>
    )
}

export default AllBookkeepers
